import { Component, Input } from '@angular/core';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'invalid-access',
  templateUrl: 'invalid-access.component.html',
  styleUrls: ['invalid-access.component.scss']
})
export class InvalidAccessComponent {
  @Input()
  errorMessage = 'You do not have access to the page you’ve requested';
  constructor() {}
}
